if (!window['DispatchEvent']) {
  window['DispatchEvent'] = function(elem, eventName) {
    var event;
    // Non-IE
    if (typeof(Event) === 'function') {
        event = new Event(eventName);
    // IE
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    elem.dispatchEvent(event);
    return event;
  }
}
/* global DispatchEvent */

if (!window['Require']) {
  window['Require'] = (function() {
    var Require;
  
    function onstate(elem, state) {
      if (state === 'complete' || state === 'loaded' || state === 'error') {
        elem.onload = elem.onerror = elem.onreadystatechange = null;
        var required = Require.required[elem.id];
        required.finished = true;
        required.errored = state === 'error';
        if (required.errored) {
          Require.onerror();
        } else {
          Require.onload();
        }
      }    
    }
  
    function onload()  { onstate(this, 'complete'); }
    function onerror() { onstate(this, 'error'); }
    function onrsc()   { onstate(this, this.readyState); }  
  
    Require = function(id, src) {
      if (Require.required[id]) { return; } // Already loaded
      Require.required[id] = {src:src};
      
      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.onload = onload;
      script.onerror = onerror;
      script.onreadystatechange = onrsc;
    
      // Note script load is async by default
      document.head.appendChild(script);
    };
    Require.required = {};
    Require.onload = Require.onerror = function() { DispatchEvent(window, 'require'); };
    return Require;
  })();
}
/* global Require */

Require("gapi", "https://apis.google.com/js/api.js");


